import {Component, Input} from '@angular/core';
import {File} from 'app/entities/file.entity';
import {BlockElementGalleryFilesViewList, BlockElementGalleryImagesViewList} from 'app/entities/enums';

@Component({
  selector: 'app-file-slider-items',
  templateUrl: 'item.html',
  styleUrls: ['item.scss'],
})
export class FileSliderItemsComponent {
  _files: File[] = [];
  docFiles: File[] = [];
  imageFiles: File[] = [];

  @Input() inContainer: boolean = true;

  @Input() fileGridView: BlockElementGalleryFilesViewList = 'grid';
  @Input() imagesGridView: BlockElementGalleryImagesViewList = 'slider';

  get files(): File[] {
    return this._files;
  }

  @Input() set files(files: File[]) {
    this._files = files;

    this.prepareFiles();
  };

  prepareFiles() {

    if (this.imagesGridView === 'slider') {
      const filesArray = {doc: [], image: [], video: []};
      this._files?.forEach((value, index) => {
        filesArray[value.fileType()].push(value);
      });
      this.docFiles = filesArray.doc;
      this.imageFiles = [...filesArray.image, ...filesArray.video];
    } else {
      this.docFiles = this._files;
    }

  }
}
